var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cookieData)?_c('DonationPaymentSuccess',{attrs:{"type":_vm.cookieData.meta.type_label,"amount":_vm.cookieData.amount.toString(),"title":_vm.cookieData.meta.donation_title,"payment":_vm.cookieData.meta}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }